import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardGrid, CellButton, Div, FormItem, Header, Input, Panel } from '@vkontakte/vkui';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { mnemonicValidate } from 'ton-crypto';
import { VldBuilder, vlds } from 'validatorus-react';
import copy from 'copy-to-clipboard';
import { CustomWallet } from '../../logic/wallet';
export const Reg = (props) => {
    const [firstRender, setFirstRender] = React.useState(false);
    const [position, setPosition] = React.useState(0);
    const [errorWrite24, setErrorWrite24] = React.useState(false);
    const [word24, setWord24] = React.useState(undefined);
    const [wall, setWall] = React.useState(undefined);
    const history = useNavigate();
    const customW = new CustomWallet();
    const w1 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w2 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w3 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w4 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w5 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w6 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w7 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w8 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w9 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w10 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w11 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w12 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w13 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w14 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w15 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w16 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w17 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w18 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w19 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w20 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w21 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w22 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w23 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const w24 = new VldBuilder()
        .with(vlds.VLen, 0, 20)
        .withFname('1');
    const psw = new VldBuilder()
        .with(vlds.VLen, 8, 160)
        .withFname('Password');
    async function createWallet() {
        const wall1 = await CustomWallet.newWallet();
        const arr = wall1.mnemonics;
        setWall(wall1);
        setWord24(arr);
        setPosition(2);
    }
    async function createPsw() {
        if (!wall || psw.iserr !== 'valid' || !word24) {
            props.consoleLog('#3001 error psw');
            return;
        }
        const hash = await CustomWallet.KeyToHash(word24.join(' '), psw.value);
        if (!hash) {
            props.consoleLog('#3002 error hash');
            return;
        }
        customW.saveWallet({
            iv: hash.iv,
            hashFromKey: hash.hashFromKey,
            publicKey: wall.publicKey,
            address: wall.address
        });
        props.setAddressUser(wall.address);
        history('/');
    }
    async function loginWallet() {
        if (errorWrite24) {
            props.consoleLog('#3003 error 24 word');
            return;
        }
        const ww24 = [
            w1.value,
            w2.value,
            w3.value,
            w4.value,
            w5.value,
            w6.value,
            w7.value,
            w8.value,
            w9.value,
            w10.value,
            w11.value,
            w12.value,
            w13.value,
            w14.value,
            w15.value,
            w16.value,
            w17.value,
            w18.value,
            w19.value,
            w20.value,
            w21.value,
            w22.value,
            w23.value,
            w24.value
        ];
        try {
            const isMnem = await mnemonicValidate(ww24);
            if (!isMnem) {
                props.consoleLog('#3003 error mnemonic');
                return;
            }
            const w = await CustomWallet.getWalletFromMnemonic(ww24);
            setWall(w);
            setWord24(ww24);
            setPosition(2);
        }
        catch (error) {
            props.consoleLog('#3004 error mnemonic');
            console.error(error);
        }
    }
    useEffect(() => {
        if (!firstRender) {
            setFirstRender(true);
        }
    }, []);
    useEffect(() => {
        if (w1.value.indexOf(' ') !== -1) {
            const ww24 = w1.value.split(' ');
            if (ww24.length === 24) {
                w1.change(ww24[0]);
                w2.change(ww24[1]);
                w3.change(ww24[2]);
                w4.change(ww24[3]);
                w5.change(ww24[4]);
                w6.change(ww24[5]);
                w7.change(ww24[6]);
                w8.change(ww24[7]);
                w9.change(ww24[8]);
                w10.change(ww24[9]);
                w11.change(ww24[10]);
                w12.change(ww24[11]);
                w13.change(ww24[12]);
                w14.change(ww24[13]);
                w15.change(ww24[14]);
                w16.change(ww24[15]);
                w17.change(ww24[16]);
                w18.change(ww24[17]);
                w19.change(ww24[18]);
                w20.change(ww24[19]);
                w21.change(ww24[20]);
                w22.change(ww24[21]);
                w23.change(ww24[22]);
                w24.change(ww24[23]);
            }
        }
        if (w1.iserr === 'valid'
            && w2.iserr === 'valid'
            && w3.iserr === 'valid'
            && w4.iserr === 'valid'
            && w5.iserr === 'valid'
            && w6.iserr === 'valid'
            && w7.iserr === 'valid'
            && w8.iserr === 'valid'
            && w9.iserr === 'valid'
            && w10.iserr === 'valid'
            && w11.iserr === 'valid'
            && w12.iserr === 'valid'
            && w13.iserr === 'valid'
            && w14.iserr === 'valid'
            && w15.iserr === 'valid'
            && w16.iserr === 'valid'
            && w17.iserr === 'valid'
            && w18.iserr === 'valid'
            && w19.iserr === 'valid'
            && w20.iserr === 'valid'
            && w21.iserr === 'valid'
            && w22.iserr === 'valid'
            && w23.iserr === 'valid'
            && w24.iserr === 'valid') {
            setErrorWrite24(false);
        }
        else {
            setErrorWrite24(true);
        }
    }, [
        w1.value,
        w2.value,
        w3.value,
        w4.value,
        w5.value,
        w6.value,
        w7.value,
        w8.value,
        w9.value,
        w10.value,
        w11.value,
        w12.value,
        w13.value,
        w14.value,
        w15.value,
        w16.value,
        w17.value,
        w18.value,
        w19.value,
        w20.value,
        w21.value,
        w22.value,
        w23.value,
        w24.value
    ]);
    return (_jsxs(Panel, { id: props.id, children: [_jsx("br", {}), position === 0
                ? _jsxs(Div, { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        minHeight: 'calc(90vh - 70px)',
                        width: '100%',
                        boxSizing: 'border-box'
                    }, children: [_jsx("span", {}), _jsx(Header, { style: { textAlign: 'center' }, children: "DeWallet" }), _jsxs(Div, { style: { width: '100%' }, children: [_jsx(Button, { stretched: true, size: 'l', onClick: () => createWallet(), children: "Create wallet" }), _jsx(Button, { style: { marginTop: '12px' }, stretched: true, size: 'l', mode: "tertiary", onClick: () => setPosition(1), children: "Import wallet" })] })] })
                : null, position === 1
                ? _jsxs(Div, { children: [_jsx(Header, { style: { textAlign: 'center' }, children: "Import wallet" }), _jsx(CardGrid, { size: 'l', children: _jsxs(Card, { children: [_jsx(FormItem, { top: "1", children: _jsx(Input, { value: w1.value, onChange: e => w1.change(e.target.value), status: w1.iserr }) }), _jsx(FormItem, { top: "2", children: _jsx(Input, { value: w2.value, onChange: e => w2.change(e.target.value), status: w2.iserr }) }), _jsx(FormItem, { top: "3", children: _jsx(Input, { value: w3.value, onChange: e => w3.change(e.target.value), status: w3.iserr }) }), _jsx(FormItem, { top: "4", children: _jsx(Input, { value: w4.value, onChange: e => w4.change(e.target.value), status: w4.iserr }) }), _jsx(FormItem, { top: "5", children: _jsx(Input, { value: w5.value, onChange: e => w5.change(e.target.value), status: w5.iserr }) }), _jsx(FormItem, { top: "6", children: _jsx(Input, { value: w6.value, onChange: e => w6.change(e.target.value), status: w6.iserr }) }), _jsx(FormItem, { top: "7", children: _jsx(Input, { value: w7.value, onChange: e => w7.change(e.target.value), status: w7.iserr }) }), _jsx(FormItem, { top: "8", children: _jsx(Input, { value: w8.value, onChange: e => w8.change(e.target.value), status: w8.iserr }) }), _jsx(FormItem, { top: "9", children: _jsx(Input, { value: w9.value, onChange: e => w9.change(e.target.value), status: w9.iserr }) }), _jsx(FormItem, { top: "10", children: _jsx(Input, { value: w10.value, onChange: e => w10.change(e.target.value), status: w10.iserr }) }), _jsx(FormItem, { top: "11", children: _jsx(Input, { value: w11.value, onChange: e => w11.change(e.target.value), status: w11.iserr }) }), _jsx(FormItem, { top: "12", children: _jsx(Input, { value: w12.value, onChange: e => w12.change(e.target.value), status: w12.iserr }) }), _jsx(FormItem, { top: "13", children: _jsx(Input, { value: w13.value, onChange: e => w13.change(e.target.value), status: w13.iserr }) }), _jsx(FormItem, { top: "14", children: _jsx(Input, { value: w14.value, onChange: e => w14.change(e.target.value), status: w14.iserr }) }), _jsx(FormItem, { top: "15", children: _jsx(Input, { value: w15.value, onChange: e => w15.change(e.target.value), status: w15.iserr }) }), _jsx(FormItem, { top: "16", children: _jsx(Input, { value: w16.value, onChange: e => w16.change(e.target.value), status: w16.iserr }) }), _jsx(FormItem, { top: "17", children: _jsx(Input, { value: w17.value, onChange: e => w17.change(e.target.value), status: w17.iserr }) }), _jsx(FormItem, { top: "18", children: _jsx(Input, { value: w18.value, onChange: e => w18.change(e.target.value), status: w18.iserr }) }), _jsx(FormItem, { top: "19", children: _jsx(Input, { value: w19.value, onChange: e => w19.change(e.target.value), status: w19.iserr }) }), _jsx(FormItem, { top: "20", children: _jsx(Input, { value: w20.value, onChange: e => w20.change(e.target.value), status: w20.iserr }) }), _jsx(FormItem, { top: "21", children: _jsx(Input, { value: w21.value, onChange: e => w21.change(e.target.value), status: w21.iserr }) }), _jsx(FormItem, { top: "22", children: _jsx(Input, { value: w22.value, onChange: e => w22.change(e.target.value), status: w22.iserr }) }), _jsx(FormItem, { top: "23", children: _jsx(Input, { value: w23.value, onChange: e => w23.change(e.target.value), status: w23.iserr }) }), _jsx(FormItem, { top: "24", children: _jsx(Input, { value: w24.value, onChange: e => w24.change(e.target.value), status: w24.iserr }) })] }) }), _jsx(FormItem, { children: _jsx(Button, { stretched: true, size: 'l', mode: "tertiary", onClick: () => setPosition(0), children: "Cancel" }) }), _jsx(FormItem, { children: _jsx(Button, { stretched: true, size: 'l', disabled: errorWrite24, onClick: () => loginWallet(), children: "Import wallet" }) })] }) : null, position === 2
                ? _jsxs(Div, { children: [_jsx(Header, { style: { textAlign: 'center' }, children: "Save 24 word" }), word24
                            ? _jsx(CardGrid, { size: "m", children: word24.map((word, key) => (_jsx(Card, { children: _jsx(CellButton, { centered: true, onClick: () => {
                                            copy(word24.join(' '));
                                            props.consoleLog('Copyed', true);
                                        }, children: word }) }, key))) })
                            : null, _jsx(Button, { style: { marginTop: '22px' }, stretched: true, size: 'l', onClick: () => setPosition(3), children: "I`m saved 24 word" })] }) : null, position === 3
                ? _jsxs(Div, { children: [_jsx(Header, { style: { textAlign: 'center' }, children: "\u0421reate a password" }), _jsx(FormItem, { top: "Password", bottom: psw.error, children: _jsx(Input, { value: psw.value, onChange: e => psw.change(e.target.value), status: psw.iserr, type: "password" }) }), _jsx(FormItem, { children: _jsx(Button, { style: { marginTop: '22px' }, stretched: true, size: 'l', disabled: psw.iserr !== 'valid', onClick: () => createPsw(), children: "Start" }) })] }) : null] }));
};
